import CloudsTSL from "./CloudsTSL";
import { Billboard } from "@react-three/drei";
import { useSnapshot } from "valtio";
import { state } from "./store";

export default function CloudsComposition() {
  const { finishedIntro } = useSnapshot(state);

  // Debug log to track when clouds should be visible
  // console.log("CloudsComposition: finishedIntro =", finishedIntro);

  // Always render clouds but with different visibility based on intro state
  // This ensures the shader is always initialized properly

  return (
    <Billboard>
      <CloudsTSL
        position={[-1, -5, 155]}
        size={[30, 20]}
        seed={43.45}
        speed={0.5}
        noiseScale={1.1}
        windDirection={[0.2, 0.5]}
        cloudDensity={0.8}
        distortionStrength={1.8}
        detailAmount={0.25}
        contrast={0.6}
        opacity={finishedIntro ? 0 : 1} // Fade out when intro finishes
        cloudDarkColor={"#aebdd2"}
        cloudLightColor={"#ffffff"}
        mouseErase={0.09}
        mouseDistortion={0.06}
        mouseFade={0.02}
      />
      <CloudsTSL
        position={[1, 3, 157]}
        rotation={[0, 0, -Math.PI]}
        size={[20, 20]}
        // seed={43.45}
        speed={0.25}
        noiseScale={3.2}
        windDirection={[0.1, -0.9]}
        cloudDensity={0.8}
        distortionStrength={2.2}
        detailAmount={0.35}
        contrast={0.7}
        opacity={finishedIntro ? 0 : 1} // Fade out when intro finishes
        cloudDarkColor={"#aebdd2"}
        cloudLightColor={"#ffffff"}
        mouseErase={0.09}
        mouseDistortion={0.06}
        mouseFade={0.02}
      />
    </Billboard>
  );
}
